import React from 'react'
import styles from './styles.module.css'

const UseCasesNumberedList = ({ children }) => {
  const listItems = getItems(children).map((item, index) => <li key={index}>{item}</li>)

  if (listItems) {
    return <ul className={`${styles.useCasesNumered}`}>{listItems}</ul>
  } else {
    return <ul className={`${styles.useCasesNumered}`}></ul>
  }
}

function getItems(children) {
  return children
    ? children
        .toString()
        .split('\n')
        .filter(i => i.toString().length > 0)
    : []
}

export default UseCasesNumberedList
